import React, { createContext, useContext } from 'react';

/**
 * When the app bar shows the current page title, this context holds that title
 * so PageLayout can hide its own title and avoid duplication (one header).
 */
const PageHeaderContext = createContext<string | null>(null);

export function usePageHeaderTitle(): string | null {
  return useContext(PageHeaderContext);
}

export const PageHeaderProvider = PageHeaderContext.Provider;
